<template>
	<div>
		<div v-if="corporate_images">
			<vx-card :title="$t('corporate_banners')" class="carousel-example corporate">
			  <swiper :options="swiperOption">
				<swiper-slide class="" v-for="(image, index) in corporate_images[checkCorporateLanguage($i18n.locale.toUpperCase())]" :key="index">
                    <img class="responsive" :src="image.full_filepath" :style="image.link != null ? 'cursor:pointer;' : ''" v-on:click="openLink(image.link)">
                </swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			  </swiper>
			</vx-card>
		</div>

		<div v-if="hotel_images">
			<vx-card :title="user.hotel.hotel_name" class="carousel-example hotel">
			  <swiper :options="swiperOption">
				<swiper-slide class="" v-for="(image, index) in hotel_images[checkHotelLanguage($i18n.locale.toUpperCase())]" :key="index">
                    <img class="responsive" :src="image.full_filepath" :style="image.link != null ? 'cursor:pointer;' : ''" v-on:click="openLink(image.link)">
                </swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			  </swiper>
			</vx-card>
		</div>
	</div>
</template>

<script>

import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

//load configurations on theme
import themeConfig from '@/../themeConfig.js';

export default {
	props: ['corporate_images', 'hotel_images'],
    data() {
        return {
            user: JSON.parse(localStorage.getItem('userSession')),
			corporateImages: [],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    }
                }
            }
        }
    },
    methods : {
        openLink (link) {   
            if (link != null) {
                window.open(link, "_blank");   
            } 
        },

        checkCorporateLanguage(lang) {
            if (this.corporate_images[lang] && this.corporate_images[lang].length > 0) {
                return lang;
            } else {
                return 'PT';
            }
        },

        checkHotelLanguage(lang) {
            if (this.hotel_images[lang] && this.hotel_images[lang].length > 0) {
                return lang;
            } else {
                return 'PT';
            }
        },
    },
    components: {
        swiper,
        swiperSlide
    }
}
</script>
